import produce from 'immer';
import { getStartDate, getInitialFromDate } from '../helpers';
import { ALL_LIMIT_TYPE, LAST_24_HOURS_VALUE } from '../constants';
import {
    RG_HISTORY_SET_ERROR,
    RG_HISTORY_TOGGLE_LOADING,
    RG_HISTORY_UPDATE_PROPERTY,
    RG_HISTORY_UPDATE_LIMIT_TYPE,
    RG_HISTORY_UPDATE_ENABLED_TYPES
} from './actions';

export const defaultState = {
    limits: [],
    limitType: ALL_LIMIT_TYPE,
    period: LAST_24_HOURS_VALUE,
    descriptions: [],
    enabledLimitTypes: [],
    from: getInitialFromDate(),
    until: new Date(),
    startDate: getStartDate(LAST_24_HOURS_VALUE),
    isLoading: true,
    error: ''
};

export const reducer = (reducerSuffix) => produce((draftState, action) => {
    switch (action.type) {
        case RG_HISTORY_UPDATE_PROPERTY:
        case RG_HISTORY_UPDATE_PROPERTY + reducerSuffix: {
            const { name, value } = action.payload;

            Object.assign(draftState, {
                [name]: value
            });

            break;
        }

        case RG_HISTORY_UPDATE_LIMIT_TYPE:
        case RG_HISTORY_UPDATE_LIMIT_TYPE + reducerSuffix: {
            const { limitType } = action.payload;

            Object.assign(draftState, {
                limitType,
                descriptions: limitType === ALL_LIMIT_TYPE ? draftState.enabledLimitTypes : [{ type: limitType }]
            });

            break;
        }

        case RG_HISTORY_UPDATE_ENABLED_TYPES:
        case RG_HISTORY_UPDATE_ENABLED_TYPES + reducerSuffix: {
            const { enabledLimitTypes } = action.payload;

            Object.assign(draftState, {
                enabledLimitTypes,
                descriptions: enabledLimitTypes
            });

            break;
        }

        case RG_HISTORY_TOGGLE_LOADING:
        case RG_HISTORY_TOGGLE_LOADING + reducerSuffix: {
            Object.assign(draftState, {
                isLoading: action.payload
            });

            break;
        }

        case RG_HISTORY_SET_ERROR:
        case RG_HISTORY_SET_ERROR + reducerSuffix: {
            Object.assign(draftState, {
                error: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
